import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-exclamation-circle",
  "use": "foquz-icon-exclamation-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" id=\"foquz-icon-exclamation-circle\"><path clip-rule=\"evenodd\" d=\"M8 15A7 7 0 108 1a7 7 0 000 14z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M7 5a1 1 0 012 0v3a1 1 0 01-2 0V5zm0 6a1 1 0 112 0 1 1 0 01-2 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol